import { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import { InputPhone } from 'components/inputs/phoneInput';
import { Loader } from 'components/loader/loader';
import axios from 'axios';
import { FormSelect } from 'components/inputs/selectField';
import { validationProfile } from './validation';
import { DateInput } from 'components/inputs/birthdayInput';
import { formatDate2 } from 'components/utils';
import {Spinner} from '../../Spinner/Spinner';

export const ProfileStep = ({ phone, token, user, setStep, setError }) => {
    const [selectedRegionOption, setSelectedRegionOption] = useState(null);
    const [selectedDisctrictOption, setSelectedDisctrictOption] = useState(null);
    const [regionOptions, setRegionOptions] = useState(null);
    const [loading, setLoading] = useState(true);
    const [region, setRegion] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [date, setDate] = useState(new Date());
    const [questions, setQuestions] = useState([]);
    const [firstQuestion, setFirstQuestion] = useState(null);
    const [secondQuestionOpt, setOpt] = useState([]);
    const [secondQuestion, setSecondQuestion] = useState(null);
    const [isLoad, setIsLoad] = useState(false)

    useEffect(() => {
        setLoading(true);
        axios
            .get(`/auth/register/questions`)
            .then((data) => setQuestions(data.data.data));
    }, []);

    useEffect(() => {
        user &&
        user.region &&
        user.region.id &&
        axios
            .get(`/district/list/${user.region.id}`)
            .then((data) => {
                setRegionOptions(data.data);
            });
    }, [user]);

    useEffect(() => {
        setLoading(true);
        axios
            .get(`/region/list`)
            .then((data) => setRegion(data.data))
            .then((data) => setLoading(false));
    }, []);

    useEffect(() => {
        selectedRegionOption &&
        axios
            .get(
                `/district/list/${selectedRegionOption}`
            )
            .then((data) => {
                setRegionOptions(data.data);
                setLoading(false);
            });
    }, [selectedRegionOption]);

    useEffect(() => {
        if (questions.length > 0 && firstQuestion === '4') {
            return setOpt(
                questions[1].answers.filter((e) => {
                    return e.id !== 6;
                })
            );
        }
        questions.length > 0 && setOpt(questions[1].answers);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [firstQuestion]);

    const getRegionOpt = () => {
        if (regionOptions)
            return regionOptions.data.map((e) => {
                return { value: e.id, label: e.name };
            });
    };

    const initialValues = {
        surname: user?.surname || '',
        name: user?.name || '',
        phone: phone,
        email: user?.email || '',
        birthday: user?.birthday ? new Date(user?.birthday) : new Date(),
        district_id: user?.district?.id || '',
        region_id: user?.region?.id || '',
        address: user?.address || '',
        patronymic: user?.patronymic || '',
        street: '',
        flat: '',
        house: '',
        city: user?.address || '',
        question1: '',
        question2: '',
    };

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <section className='login login_auto'>

                    <div className='login__content'>
                        <p className='login__info'>
                            Оставьте ваши контактные данные для информирования о мероприятиях
                            проекта «Женское движения ЕДИНОЙ РОССИИ» в Вашем регионе, а также
                            получения информационных материалов
                        </p>
                        <Formik
                            initialValues={{ ...initialValues }}
                            validate={(values) => {
                                return validationProfile(values);
                            }}
                            onSubmit={(values, { setErrors }) => {
                                setIsLoad(true)
                                const fullAdress = `${values.city}, ${values.street}, ${values.house},${values.flat}`;
                                const prepData = {
                                    name: values.name,
                                    email: values.email,
                                    surname: values.surname,
                                    patronymic: values.patronymic || '',
                                    phone: values.phone,
                                    birthday: formatDate2(values.birthday),
                                    region_id: values.region_id.value,
                                    address: fullAdress,
                                    district_id: values.district_id.value,
                                    questions: [
                                        {
                                            id: 1,
                                            answer_id: values.question1.value,
                                            answer_text: values.question1Text
                                                ? values.question1Text
                                                : null,
                                        },
                                        {
                                            id: 2,
                                            answer_id: values.question2.value,
                                            answer_text: values.question2Text
                                                ? values.question2Text
                                                : null,
                                        },
                                        {
                                            id: 3,
                                            answer_id: 10,
                                            answer_text: values.question3,
                                        },
                                    ],
                                };
                                axios.defaults.headers.common[
                                    'Authorization'
                                    ] = `Bearer ${token}`;
                                axios
                                    .post(`/auth/register`, {
                                        ...prepData,
                                    })
                                    .then((data) => {
                                        data.status === 200 && setStep(4);
                                    })
                                    .catch((e) => {
                                        if (e.response.status === 422) {
                                            return setErrors(e.response.data.errors);
                                        }
                                        setError(e.response.data.message)
                                        return setStep(5);
                                    }).finally(()=> setIsLoad(false))
                            }}
                        >
                            {({
                                  values,
                                  errors,
                                  touched,
                                  handleChange,
                                  handleBlur,
                                  handleSubmit,
                                  setFieldValue,
                              }) => (
                                <Form
                                    className='login__form form form_questionary js-form js-ajax-form'
                                    onSubmit={handleSubmit}
                                >
                                    <div className='form__top'>
                                        <div className='form__wrap'>
                                            <label className='form__label' htmlFor='surname'>
                                                Фамилия*
                                                <Field
                                                    className={
                                                        errors.surname && touched.surname  ? 'form__input error' : 'form__input'
                                                    }
                                                    onChange={handleChange}
                                                    value={values.surname}
                                                    id='surname'
                                                    name='surname'
                                                    type='text'
                                                    placeholder='Фамилия'
                                                />
                                                <span className='authorization__error'>
													{errors.surname && touched.surname && errors.surname}
												</span>
                                            </label>
                                        </div>
                                        <div className='form__wrap'>
                                            <label className='form__label' htmlFor='name'>
                                                Имя*
                                                <Field
                                                    onChange={handleChange}
                                                    value={values.name}
                                                    className={
                                                        errors.name && touched.name  ? 'form__input error' : 'form__input'
                                                    }
                                                    id='name'
                                                    name='name'
                                                    type='text'
                                                    placeholder='Имя'
                                                />
                                                <span className='authorization__error'>
													{errors.name && touched.name && errors.name}
												</span>
                                            </label>
                                        </div>
                                        <div className='form__wrap'>
                                            <label className='form__label' htmlFor='patronymic'>
                                                Отчество (если есть)
                                                <Field
                                                    onChange={handleChange}
                                                    value={values.patronymic}
                                                    className='form__input'
                                                    id='patronymic'
                                                    name='patronymic'
                                                    type='text'
                                                    placeholder='Отчество'
                                                />
                                                <span className='authorization__error'>
													{errors.patronymic}
												</span>
                                            </label>
                                        </div>

                                        <div className='form__wrap'>
                                            <label className='form__label' htmlFor='birthday'>
                                                Дата рождения*
                                                <Field
                                                    className={
                                                        errors.birthday &&
                                                        touched.birthday
                                                            ? 'form__input  error'
                                                            : 'form__input '
                                                    }
                                                    id='birthday'
                                                    component={DateInput}
                                                    clearIcon={null}
                                                    // calendarIcon={null}
                                                    monthPlaceholder={'ММ'}
                                                    dayPlaceholder={'ДД'}
                                                    yearPlaceholder={'ГГГГ'}
                                                    onChange={setDate}
                                                    value={values.birthday}
                                                    name='birthday'
                                                    type='text'
                                                    placeholder='ДД.ММ.ГГГГ'
                                                />
                                                <span className='authorization__error'>
													{errors.birthday &&
                                                        touched.birthday &&
                                                        errors.birthday}
												</span>
                                            </label>
                                        </div>
                                        <div className='form__wrap'>
                                            <label className='form__label' htmlFor='phone'>
                                                Номер телефона*
                                                <InputPhone
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    readOnly
                                                    className={
                                                        errors.phone ? 'form__input error' : 'form__input'
                                                    }
                                                    disabled={true}
                                                    value={values.phone}
                                                />
                                            </label>
                                        </div>
                                        <div className='form__wrap'>
                                            <label className='form__label' htmlFor='email'>
                                                Адрес электронной почты*
                                                <Field
                                                    className={
                                                        errors.email  && touched.email ? 'form__input error' : 'form__input'
                                                    }
                                                    id='email'
                                                    name='email'
                                                    onChange={handleChange}
                                                    value={values.email}
                                                    type='text'
                                                    placeholder='Email'
                                                />
                                                <span className='authorization__error'>
													{errors.email && touched.email && errors.email}
												</span>
                                            </label>
                                        </div>

                                        <div className='form__wrap'>
                                            <label className='form__label'>
                                                Регион*
                                                <Field
                                                    name='region_id'
                                                    component={FormSelect}
                                                    className={
                                                        errors.region_id &&
                                                        touched.region_id
                                                            ? 'form__input form__input_select error'
                                                            : 'form__input form__input_select'
                                                    }
                                                    value={selectedRegionOption}
                                                    placeholder='Выберите'
                                                    defaultValue={{
                                                        value: user?.region?.id,
                                                        label: user?.region?.name,
                                                    }}
                                                    onChange={(e) => [
                                                        setSelectedRegionOption(e),
                                                        setFieldValue('district_id', ''),
                                                    ]}
                                                    options={region.data.map((e) => {
                                                        return { value: e.id, label: e.name };
                                                    })}
                                                />
                                                <span className='authorization__error'>
													{errors.region_id &&
                                                        touched.region_id &&
                                                        errors.region_id}
												</span>
                                            </label>
                                        </div>
                                        <div className='form__wrap'>
                                            <label className='form__label' htmlFor='district_id'>
                                                Район*
                                                <Field
                                                    name='district_id'
                                                    className={
                                                        errors.district_id &&
                                                        touched.district_id
                                                            ? ' form__input form__input_select error'
                                                            : 'form__input form__input_select'
                                                    }
                                                    component={FormSelect}
                                                    placeholder='Выберите'
                                                    defaultValue={{
                                                        value: user?.district?.id,
                                                        label: user?.district?.name,
                                                    }}
                                                    options={getRegionOpt()}
                                                    value={selectedDisctrictOption}
                                                    onChange={setSelectedDisctrictOption}
                                                />
                                                <span className='authorization__error'>
													{errors.district_id &&
                                                        touched.district_id &&
                                                        errors.district_id}
												</span>
                                            </label>
                                        </div>
                                        <div className='form__wrap'>
                                            <label className='form__label' htmlFor='city'>
                                                Адрес*
                                                <Field
                                                    className={
                                                        errors.address  && touched.city ? 'form__input error' : 'form__input'
                                                    }
                                                    id='city'
                                                    onChange={handleChange}
                                                    value={values.city}
                                                    name='city'
                                                    type='text'
                                                    placeholder='Адрес'
                                                />
                                                <span className='authorization__error'>
													{errors.city && touched.city && errors.city}
												</span>
                                            </label>
                                        </div>
                                        <div className='form__wrap'>
                                            <label className='form__label' htmlFor='street'>
                                                Улица
                                                <Field
                                                    className={
                                                        errors.street  && touched.street ? 'form__input error' : 'form__input'
                                                    }
                                                    id='street'
                                                    onChange={handleChange}
                                                    value={values.street}
                                                    name='street'
                                                    type='text'
                                                    placeholder='Улица'
                                                />
                                                <span className='authorization__error'>
													{errors.street && touched.street && errors.street}
												</span>
                                            </label>
                                        </div>
                                        <div className='form__wrap'>
                                            <label className='form__label' htmlFor='house'>
                                                Дом
                                                <Field
                                                    className={
                                                        errors.house && touched.house  ? 'form__input error' : 'form__input'
                                                    }
                                                    id='house'
                                                    onChange={handleChange}
                                                    value={values.house}
                                                    name='house'
                                                    type='text'
                                                    placeholder='Дом'
                                                />
                                                <span className='authorization__error'>
													{errors.house && touched.house && errors.house}
												</span>
                                            </label>
                                        </div>
                                        <div className='form__wrap'>
                                            <label className='form__label' htmlFor='flat'>
                                                Квартира
                                                <Field
                                                    className={
                                                        errors.flat && touched.flat  ? 'form__input error' : 'form__input'
                                                    }
                                                    id='flat'
                                                    onChange={handleChange}
                                                    value={values.flat}
                                                    name='flat'
                                                    type='text'
                                                    placeholder='Квартира'
                                                />
                                                <span className='authorization__error'>
													{errors.flat && touched.flat && errors.flat}
												</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className='form__center'>
                                        <div className='form__wrap'>
                                            <label className='form__label' htmlFor='question1'>
                                                В какой области вы заняты*
                                                <Field
                                                    name='question1'
                                                    className={
                                                        errors.question1 &&
                                                        touched.question1
                                                            ? ' form__input form__input_select error'
                                                            : 'form__input form__input_select'
                                                    }
                                                    component={FormSelect}
                                                    placeholder='Выберите'
                                                    options={questions[0]?.answers?.map((e) => {
                                                        return { value: e.id, label: e.title };
                                                    })}
                                                    value={firstQuestion}
                                                    onChange={(e) => {
                                                        setFirstQuestion(e);
                                                        setFieldValue('question2', '');
                                                        setFieldValue('question1Text', undefined);
                                                        if (e === '4') {
                                                            setFieldValue('question1Text', '');
                                                        }
                                                    }}
                                                />
                                                <span className='authorization__error'>
													{errors.question1 &&
                                                        touched.question1 &&
                                                        errors.question1}
												</span>
                                            </label>
                                        </div>
                                        {firstQuestion === '4' && (
                                            <div className='form__wrap'>
                                                <label className='form__label' htmlFor='question1Text'>
                                                    Укажите иное
                                                    <Field
                                                        className={
                                                            errors.question1Text &&
                                                            touched.question1Text
                                                                ? 'form__input error'
                                                                : 'form__input'
                                                        }
                                                        id='question1Text'
                                                        onChange={handleChange}
                                                        value={values.question1Text}
                                                        name='question1Text'
                                                        type='text'
                                                        placeholder='Укажите иное'
                                                    />
                                                    <span className='authorization__error'>
														{errors.question1Text &&
                                                            touched.question1Text &&
                                                            errors.question1Text}
													</span>
                                                </label>
                                            </div>
                                        )}
                                        <div className='form__wrap'>
                                            <label className='form__label' htmlFor='question2'>
                                                Сфера ваших интересов при взаимодействии с проектом
                                                «Женское движение ЕДИНОЙ РОССИИ»*
                                                <Field
                                                    name='question2'
                                                    className={
                                                        errors.question2 &&
                                                        touched.question2
                                                            ? ' form__input form__input_select error'
                                                            : 'form__input form__input_select'
                                                    }
                                                    component={FormSelect}
                                                    placeholder='Выберите'
                                                    options={secondQuestionOpt?.map((e) => {
                                                        return { value: e.id, label: e.title };
                                                    })}
                                                    value={secondQuestion}
                                                    onChange={(e) => {
                                                        setFieldValue('question2Text', undefined);
                                                        if (e === '9') {
                                                            setFieldValue('question2Text', '');
                                                        }

                                                        setSecondQuestion(e);
                                                    }}
                                                />
                                                <span className='authorization__error'>
													{errors.question2 &&
                                                        touched.question2 &&
                                                        errors.question2}
												</span>
                                            </label>
                                        </div>
                                        {secondQuestion === '9' && (
                                            <div className='form__wrap'>
                                                <label className='form__label' htmlFor='question2Text'>
                                                    Укажите иное
                                                    <Field
                                                        className={
                                                            errors.question2Text &&
                                                            touched.question2Text
                                                                ? 'form__input error'
                                                                : 'form__input'
                                                        }
                                                        id='question2Text'
                                                        onChange={handleChange}
                                                        value={values.question2Text}
                                                        name='question2Text'
                                                        type='text'
                                                        placeholder='Укажите иное'
                                                    />
                                                    <span className='authorization__error'>
														{errors.question2Text &&
                                                            touched.question2Text &&
                                                            errors.question2Text}
													</span>
                                                </label>
                                            </div>
                                        )}
                                        <div className='form__wrap'>
                                            <label className='form__label' htmlFor='question3'>
                                                Информация о себе
                                                <Field
                                                    className={
                                                        errors.question3 &&
                                                        touched.question3  ? 'form__input error' : 'form__input'
                                                    }
                                                    id='question3'
                                                    onChange={handleChange}
                                                    value={values.question3}
                                                    name='question3'
                                                    type='text'
                                                    placeholder='Информация о себе'
                                                />
                                                <span className='authorization__error'>
													{errors.question3 &&
                                                        touched.question3 &&
                                                        errors.question3}
												</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className='authorization__btn-block'>

                                        <button
                                            className='form__button button'
                                            type='submit'
                                            disabled={isLoad}
                                        >
                                            {isLoad && <div className="form_loader"><Spinner/></div> }
                                            <span className="form__btn-text">Зарегистрироваться</span>
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </section>
            )}
        </>
    );
};
